import coreApiService from './core.service';

const LIST = 'pv/article/list';
const DETAIL = 'pv/article/slug';

export const articleApi = {
    list: (limit: number, offset: number) => coreApiService.get(LIST, { limit, offset }),
    detail: (slug: string) => coreApiService.get(`${DETAIL}/${slug}`),
};
